<div
  class="combine-food-container"
  [ngClass]="{ 'combine-food-error': combineFoodError }"
  *ngIf="showBanner"
>
  <div class="combine-food-header">
    <div class="combine-food-icon">
      <img
        src="../../../assets/icons/dry-and-wet-combination.svg"
        alt="Ícone Combinar Alimentação"
      />
    </div>
    <div class="combine-food-header-message">
      <h4 class="combine-food-title">Combinar Alimentação</h4>
      <p class="combine-food-desc">
        Defina a proporção da <span>Alimentação Úmida</span> para
        <span>Alimentação Seca</span>.
      </p>
    </div>
  </div>
  <div class="combine-food-actions">
    <ng-template
      #combineInputContainer
      let-type="type"
      let-percentage="percentage"
      let-icon="icon"
      let-label="label"
    >
      <div class="combine-input-container">
        <div class="combine-input-wrapper">
          <input
            type="number"
            min="1"
            max="99"
            step="1"
            inputmode="numeric"
            pattern="[0-9]*"
            [value]="percentage"
            (input)="handleInput($event, type)"
            (keydown)="preventInvalidChars($event)"
            (paste)="handlePaste($event)"
            class="combine-input"
          />
          <span class="combine-percentage">%</span>
        </div>
        <div class="combine-tag">
          <img [src]="icon" alt="Ícone" class="combine-label-icon" />
          <span class="combine-label">{{ label }}</span>
        </div>
      </div>
    </ng-template>

    <ng-container
      *ngTemplateOutlet="
        combineInputContainer;
        context: {
          type: 'dry',
          percentage: dryPercentage,
          icon: '../../../assets/icons/dry-food-icon.svg',
          label: 'Seco'
        }
      "
    ></ng-container>

    <div class="combine-food-bowl">
      <img
        [src]="'../../../assets/icons/' + getWetFoodBowlImage()"
        alt="Tigela de ração"
      />
    </div>

    <ng-container
      *ngTemplateOutlet="
        combineInputContainer;
        context: {
          type: 'wet',
          percentage: wetPercentage,
          icon: '../../../assets/icons/wet-food-icon.svg',
          label: 'Úmido'
        }
      "
    ></ng-container>
  </div>
</div>

<div *ngIf="combineFoodError" class="combine-food-error-message">
  Defina a proporção da Alimentação Úmida e Seca.
</div>
